var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760.193,
    height: 637.549,
    viewBox: "0 0 760.193 637.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-200.914 -142.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11147",
    "data-name": "Group 11147",
    transform: "translate(200.914 154.281)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11146",
    "data-name": "Group 11146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11145",
    "data-name": "Group 11145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11144",
    "data-name": "Group 11144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M941.555,653.038c-14.614,33.025-34.88,59.2-59.117,79.725-27.988,23.711-61.273,39.9-97.268,50.423-117.113,34.258-262.89,8.615-348.137-12.659-17.287-4.315-32.084-8.451-43.648-11.87A188.443,188.443,0,0,1,338.694,732.4l-.261-.183C224.189,652.1,175.667,537.6,213.653,429.157c.59-1.692,112.59-346.095,378.164-232.353C708.4,246.738,665.52,289.169,794.75,342.24c60.417,24.813,140.367,69.072,162.3,173.474C964.875,552.973,962.239,606.293,941.555,653.038Z",
    transform: "translate(-200.914 -173.771)",
    fill: "#c9e1fd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11162",
    "data-name": "Group 11162",
    transform: "translate(439.861 279.377)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    "data-name": "Path 3510",
    d: "M1327.728,656.008a65.066,65.066,0,0,0,19.178,8.833l2.473,17.129,11.825.459,11.825.459L1376.822,666a65.07,65.07,0,0,0,19.806-7.319l13.862,10.365,8.686-8.037,8.686-8.037L1418.6,638.35a65.059,65.059,0,0,0,8.833-19.179l17.13-2.473.459-11.825.459-11.825-16.886-3.793a65.063,65.063,0,0,0-7.319-19.806l10.365-13.863-8.037-8.686-8.037-8.686-14.624,9.259a65.069,65.069,0,0,0-19.179-8.833l-2.473-17.13-11.825-.459-11.825-.459-3.793,16.886a65.074,65.074,0,0,0-19.805,7.319l-13.862-10.366-8.686,8.037-8.686,8.037,9.259,14.625a65.062,65.062,0,0,0-8.833,19.178l-17.129,2.472-.459,11.825-.459,11.825,16.886,3.793a65.064,65.064,0,0,0,7.319,19.806l-10.366,13.863,8.037,8.686,8.037,8.686Zm6.458-86.854a44.4,44.4,0,1,1-2.436,62.739A44.4,44.4,0,0,1,1334.186,569.154Z",
    transform: "translate(-1130.545 -520.594)",
    fill: "#2ecc71",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    d: "M967.678,1235.8a61.336,61.336,0,0,0-18.726-6.75l-3.7-15.89-11.144.522-11.144.522-2.2,16.166a61.333,61.333,0,0,0-18.012,8.472l-13.856-8.618-7.511,8.249-7.511,8.249,9.876,12.99a61.338,61.338,0,0,0-6.75,18.726l-15.89,3.7.522,11.144.522,11.144,16.166,2.2a61.327,61.327,0,0,0,8.472,18.013l-8.618,13.856,8.249,7.511,8.249,7.511,12.99-9.876a61.333,61.333,0,0,0,18.726,6.75l3.7,15.89,11.144-.522,11.144-.522,2.2-16.166a61.332,61.332,0,0,0,18.012-8.472l13.856,8.618,7.511-8.249,7.511-8.249-9.876-12.99a61.33,61.33,0,0,0,6.75-18.726l15.89-3.7-.522-11.144-.522-11.144-16.166-2.2a61.326,61.326,0,0,0-8.472-18.013l8.618-13.856-8.249-7.51-8.249-7.511Zm.938,82.1a41.853,41.853,0,1,1-2.771-59.124A41.853,41.853,0,0,1,968.616,1317.9Z",
    transform: "translate(-861.107 -962.703)",
    fill: "#2ecc71",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3512",
    "data-name": "Path 3512",
    d: "M1397.053,1519.734a38.348,38.348,0,0,0-8.977-8.617L1390,1501.1l-6.5-2.536-6.5-2.536-5.369,8.672a38.342,38.342,0,0,0-12.441.257l-5.721-8.446-6.387,2.8-6.387,2.8,2.336,9.93a38.351,38.351,0,0,0-8.617,8.977l-10.016-1.926-2.536,6.5-2.536,6.5,8.672,5.369a38.349,38.349,0,0,0,.257,12.441l-8.445,5.721,2.8,6.387,2.8,6.387,9.93-2.336a38.351,38.351,0,0,0,8.977,8.617l-1.926,10.016,6.5,2.536,6.5,2.536,5.369-8.672a38.342,38.342,0,0,0,12.441-.257l5.721,8.445,6.387-2.8,6.387-2.8-2.336-9.93a38.356,38.356,0,0,0,8.617-8.977L1408,1566.7l2.536-6.5,2.536-6.5-8.672-5.369a38.349,38.349,0,0,0-.257-12.441l8.445-5.721-2.8-6.387-2.8-6.387Zm-20.344,47.123a26.164,26.164,0,1,1,13.455-34.469A26.164,26.164,0,0,1,1376.708,1566.857Z",
    transform: "translate(-1152.749 -1143.19)",
    fill: "#2ecc71",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11169",
    "data-name": "Group 11169",
    transform: "translate(303.892 348.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11168",
    "data-name": "Group 11168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11167",
    "data-name": "Group 11167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11166",
    "data-name": "Group 11166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11165",
    "data-name": "Group 11165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11164",
    "data-name": "Group 11164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11163",
    "data-name": "Group 11163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    "data-name": "Path 3513",
    d: "M544.91,732.923s-19.2-31.752-65.279-23.518C479.631,709.4,510.649,755.4,544.91,732.923Z",
    transform: "translate(-479.631 -708.041)",
    fill: "#27bc66"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11176",
    "data-name": "Group 11176",
    transform: "translate(315.923 296.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11175",
    "data-name": "Group 11175",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11174",
    "data-name": "Group 11174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11173",
    "data-name": "Group 11173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11172",
    "data-name": "Group 11172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11171",
    "data-name": "Group 11171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11170",
    "data-name": "Group 11170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    "data-name": "Path 3514",
    d: "M595.433,651.771s-5.721-63.648-83.239-85.728C512.194,566.043,525.426,660.664,595.433,651.771Z",
    transform: "translate(-512.194 -566.043)",
    fill: "#2ecc71"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11231",
    "data-name": "Group 11231",
    transform: "translate(326.198 316.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11177",
    "data-name": "Group 11177",
    transform: "translate(161.884 47.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    d: "M986.947,771.953s21.919-5.363,28.263,2.878-9.277,30.968-21.144,32.733S986.947,771.953,986.947,771.953Z",
    transform: "translate(-986.009 -770.238)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11178",
    "data-name": "Group 11178",
    transform: "translate(22.427 244.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M687,1411.652s55.778-27.086,66-65.346-55.427-43.15-54.514-43.145-66.678,17.91-71.294,28.832-24.911,56.43-16.7,56.471S687,1411.652,687,1411.652Z",
    transform: "translate(-608.559 -1303.161)",
    fill: "#ed7163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11200",
    "data-name": "Group 11200",
    transform: "translate(11.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11180",
    "data-name": "Group 11180",
    transform: "translate(5.322 5.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11179",
    "data-name": "Group 11179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M726.062,659.073c-.016-.082-.034-.164-.054-.245a5.578,5.578,0,0,0-6.026-4.3q-.125.012-.25.029c-.028,0-.055,0-.083.01L596.91,675.042c-.027,0-.054.013-.081.018-.082.016-.164.034-.245.054a5.578,5.578,0,0,0-4.3,6.024c.007.083.017.166.028.249,0,.028.005.055.01.083l42.576,255.206a4.871,4.871,0,0,0,5.606,4l124.152-20.713a4.871,4.871,0,0,0,4-5.606L726.079,659.154C726.075,659.127,726.067,659.1,726.062,659.073Z",
    transform: "translate(-592.248 -654.495)",
    fill: "#d0f6fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11181",
    "data-name": "Group 11181",
    transform: "translate(3.01 2.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M585.991,676.074l8.892-8.548,119.645-19.644,12.029,7.477s.768,10.844.138,11.117-139.18,25.045-139.53,22.908S585.991,676.074,585.991,676.074Z",
    transform: "translate(-585.991 -647.882)",
    fill: "#f48a21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11194",
    "data-name": "Group 11194",
    transform: "translate(13.063 31.043)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11185",
    "data-name": "Group 11185",
    transform: "translate(0 1.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11184",
    "data-name": "Group 11184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11183",
    "data-name": "Group 11183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11182",
    "data-name": "Group 11182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M616.92,731.07a1.872,1.872,0,1,1-2.154-1.538A1.868,1.868,0,0,1,616.92,731.07Z",
    transform: "translate(-613.202 -729.505)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11189",
    "data-name": "Group 11189",
    transform: "translate(5.712 0.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11188",
    "data-name": "Group 11188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11187",
    "data-name": "Group 11187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11186",
    "data-name": "Group 11186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M632.381,728.49a1.873,1.873,0,0,1-1.538,2.154,1.847,1.847,0,0,1-.784-.037,1.872,1.872,0,1,1,2.323-2.117Z",
    transform: "translate(-628.662 -726.926)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11193",
    "data-name": "Group 11193",
    transform: "translate(11.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11192",
    "data-name": "Group 11192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11191",
    "data-name": "Group 11191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11190",
    "data-name": "Group 11190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M647.841,725.911a1.868,1.868,0,0,1-.808,1.865,1.872,1.872,0,0,1-2.884-1.248,1.872,1.872,0,1,1,3.693-.616Z",
    transform: "translate(-644.123 -724.347)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11198",
    "data-name": "Group 11198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11197",
    "data-name": "Group 11197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11196",
    "data-name": "Group 11196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    d: "M759.133,902.785a7.549,7.549,0,0,1-6.2,8.688L634.063,931.3a7.55,7.55,0,0,1-8.691-6.2L583.7,675.336a8.422,8.422,0,0,1,6.922-9.694L707.771,646.1a8.423,8.423,0,0,1,9.695,6.922ZM707.092,640.519,589.457,660.144a13.9,13.9,0,0,0-11.42,15.994l42.1,252.334a13.9,13.9,0,0,0,15.994,11.42l117.634-19.625a13.9,13.9,0,0,0,11.42-15.994l-42.1-252.334A13.9,13.9,0,0,0,707.092,640.519Z",
    transform: "translate(-577.845 -640.327)",
    fill: "#20111d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11201",
    "data-name": "Group 11201",
    transform: "translate(0.562 127.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    d: "M661.118,1204.941l0,.336v.106l-.161,32.4-.277,55.038c-17.574-4.388-32.618-8.594-44.374-12.071a191.552,191.552,0,0,1-55.6-26.706l-.266-.186,2.271-69.47s-14.268-64.84-13.279-80.34,11.2-51.023,15.83-64.685A65.6,65.6,0,0,0,567.9,1024.8c.036-.4.069-.8.1-1.2a.04.04,0,0,1,0-.017c.405-5.128.507-10.313.491-14.64,0-.135,0-.271,0-.409,0-.379,0-.748-.007-1.111,0-.1,0-.191,0-.287-.062-5.224-.283-8.81-.283-8.81.089-.887.214-1.717.366-2.5a21.036,21.036,0,0,1,.563-2.281c.165-.537.349-1.042.547-1.513,1.335-3.19,3.382-4.98,5.8-5.646a10.513,10.513,0,0,1,5.844.25c7.294,2.208,15.425,10.718,18.309,20.51,5.382,18.272.557,71.151.557,71.151s12.475,12.6,20.306,37.718a134.674,134.674,0,0,1,4.93,22.613,73.632,73.632,0,0,1,.65,9.021,57.85,57.85,0,0,1-.593,9.034,45.627,45.627,0,0,1-2.785,10.461c-6.549,16.262-20.319,20.629-20.319,20.629l.91.267,22.455,6.562,34.2,9.993,1.173.343Z",
    transform: "translate(-549.379 -986.081)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11204",
    "data-name": "Group 11204",
    transform: "translate(175.503 172.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11202",
    "data-name": "Group 11202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    d: "M1031.082,1108.443l1.529,9.343s-13.179,13.3-8.879,30.185,15.657,18.923,15.657,18.923,17.742-23.781,17.463-32.036S1056.5,1112.12,1031.082,1108.443Z",
    transform: "translate(-1022.87 -1108.443)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11203",
    "data-name": "Group 11203",
    transform: "translate(10.799 30.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    d: "M1060.081,1215.27s7.114-7.213,13.721-22.955a21.672,21.672,0,0,0-4.446-1.657c-4.012-1.191-6.564-.367-8.735,2.449l-8.166,11.952s-1.569,3.052,1.878,6.578C1055.658,1212.994,1060.081,1215.27,1060.081,1215.27Z",
    transform: "translate(-1052.098 -1190.13)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11205",
    "data-name": "Group 11205",
    transform: "translate(174.708 179.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M1038.269,1178.417l-.372-.092a18.833,18.833,0,0,1-9.374-5.991c-.371-.435-9.364-11.165-7.569-23.652,1.786-12.428,12.208-22.551,12.651-22.975l.778.811c-.106.1-10.586,10.285-12.317,22.324-1.721,11.977,7.234,22.672,7.325,22.779a18.142,18.142,0,0,0,8.406,5.516l10.123-14.288c10.593-15.292,5.709-27.261,5.659-27.38l1.034-.441a21.923,21.923,0,0,1,1.281,8.28c-.06,4.65-1.332,11.927-7.054,20.187Z",
    transform: "translate(-1020.717 -1125.707)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11208",
    "data-name": "Group 11208",
    transform: "translate(187.59 236.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11206",
    "data-name": "Group 11206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M1062,1280.7l1.195,7.3s-10.3,10.39-6.938,23.587,12.234,14.787,12.234,14.787,13.864-18.583,13.646-25.033S1081.866,1283.575,1062,1280.7Z",
    transform: "translate(-1055.583 -1280.702)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11207",
    "data-name": "Group 11207",
    transform: "translate(8.438 23.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    d: "M1084.66,1364.178s5.559-5.636,10.722-17.937a16.921,16.921,0,0,0-3.474-1.295c-3.135-.931-5.129-.286-6.826,1.914l-6.381,9.339s-1.226,2.384,1.468,5.14A26.414,26.414,0,0,0,1084.66,1364.178Z",
    transform: "translate(-1078.422 -1344.533)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11209",
    "data-name": "Group 11209",
    transform: "translate(186.968 241.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    d: "M1067.616,1335.381l-.291-.072a14.708,14.708,0,0,1-7.325-4.682c-.29-.34-7.318-8.724-5.915-18.482,1.4-9.711,9.54-17.621,9.886-17.953l.608.634c-.083.079-8.272,8.037-9.624,17.444-1.345,9.358,5.653,17.716,5.724,17.8a14.168,14.168,0,0,0,6.569,4.311l7.91-11.165c8.278-11.95,4.461-21.3,4.422-21.4l.808-.345c.17.4,4.062,9.869-4.51,22.244Z",
    transform: "translate(-1053.901 -1294.193)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11210",
    "data-name": "Group 11210",
    transform: "translate(28.344 302.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M670.638,1463.3s-8.89,22.99,2.494,28.955-27.417,9.144-27.411,8.019-26.809-34.423-20.055-36.075,27.871-9.416,32.624-4.333S670.638,1463.3,670.638,1463.3Z",
    transform: "translate(-624.575 -1458.166)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11213",
    "data-name": "Group 11213",
    transform: "translate(166.523 117.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11211",
    "data-name": "Group 11211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M1006.777,958.733l1.529,9.343s-13.179,13.3-8.879,30.185,15.657,18.923,15.657,18.923,17.742-23.781,17.463-32.036S1032.2,962.41,1006.777,958.733Z",
    transform: "translate(-998.565 -958.733)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212",
    transform: "translate(10.799 30.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M1035.776,1065.561s7.114-7.213,13.721-22.955a21.7,21.7,0,0,0-4.446-1.657c-4.012-1.191-6.564-.366-8.735,2.449l-8.166,11.952s-1.569,3.051,1.878,6.579C1031.353,1063.284,1035.776,1065.561,1035.776,1065.561Z",
    transform: "translate(-1027.793 -1040.42)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11214",
    "data-name": "Group 11214",
    transform: "translate(111.576 346.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2252",
    "data-name": "Rectangle 2252",
    width: 32.838,
    height: 1.124,
    transform: "translate(0 32.837) rotate(-89.714)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11215",
    "data-name": "Group 11215",
    transform: "translate(108.902 293.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    d: "M843.063,1489.335l-.454-1.029c19.1-8.425,36.843-24.634,45.247-36.128a98.843,98.843,0,0,0,10.652-17.755l1.037.435a99.9,99.9,0,0,1-10.781,17.984C880.273,1464.453,862.351,1480.826,843.063,1489.335Z",
    transform: "translate(-842.609 -1434.423)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11216",
    "data-name": "Group 11216",
    transform: "translate(19.187 133.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3534",
    "data-name": "Path 3534",
    d: "M612.563,1005.3c-1.12-3.169-9.214-3.592-11.593-3.167-1.536.274.072,30.118-1.178,31.48,0,0-.226.373,3.7.51a14.326,14.326,0,0,0,7.336-1.675S613.682,1008.473,612.563,1005.3Z",
    transform: "translate(-599.791 -1001.999)",
    fill: "#f78a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11217",
    "data-name": "Group 11217",
    transform: "translate(165.728 124.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    d: "M1013.966,1028.7l-.369-.088c-5.123-1.213-9.19-5.776-9.36-5.969-.39-.458-9.383-11.187-7.588-23.674,1.786-12.428,12.208-22.55,12.651-22.975l.778.811c-.106.1-10.586,10.285-12.317,22.324-1.721,11.976,7.234,22.672,7.325,22.778.032.036,3.8,4.257,8.4,5.519l10.125-14.29c10.593-15.292,5.709-27.261,5.659-27.381l1.034-.441a21.92,21.92,0,0,1,1.281,8.28c-.06,4.65-1.332,11.928-7.054,20.187Z",
    transform: "translate(-996.412 -975.997)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11218",
    "data-name": "Group 11218",
    transform: "translate(157.945 24.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M993.112,809.315,975.348,706.98l1.109-.182,17.765,102.335Z",
    transform: "translate(-975.348 -706.798)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11219",
    "data-name": "Group 11219",
    transform: "translate(163.466 47.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    d: "M1015.508,791.577l-.916-.651c.078-.11,7.783-11.125,2.13-17.563-5.732-6.526-25.981-2.066-26.185-2.02l-.247-1.1c.859-.193,21.109-4.648,27.276,2.375C1023.807,779.726,1015.85,791.1,1015.508,791.577Z",
    transform: "translate(-990.29 -768.675)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11224",
    "data-name": "Group 11224",
    transform: "translate(22.542 303.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11223",
    "data-name": "Group 11223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11222",
    "data-name": "Group 11222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11221",
    "data-name": "Group 11221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11220",
    "data-name": "Group 11220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M622.75,1475.07a.594.594,0,0,1-.585.061c-6.686-2.94-12.94-12.752-13.2-13.169a.593.593,0,1,1,1-.633c.063.1,6.326,9.923,12.679,12.717a.593.593,0,0,1,.107,1.024Z",
    transform: "translate(-608.87 -1461.053)",
    fill: "#000100"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11229",
    "data-name": "Group 11229",
    transform: "translate(28.147 305.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11228",
    "data-name": "Group 11228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11227",
    "data-name": "Group 11227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11226",
    "data-name": "Group 11226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11225",
    "data-name": "Group 11225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M640.408,1477a.592.592,0,0,1-.461.1c-7.163-1.429-15.387-9.66-15.734-10.01a.593.593,0,1,1,.842-.834c.082.083,8.317,8.324,15.124,9.682a.593.593,0,0,1,.229,1.063Z",
    transform: "translate(-624.041 -1466.08)",
    fill: "#000100"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11230",
    "data-name": "Group 11230",
    transform: "translate(0 127.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M601.584,1187.348l-.34-1.071a33.523,33.523,0,0,0,13.291-9.393c5.76-6.54,12.062-18.638,9.37-39.14a125.571,125.571,0,0,0-14.5-44.982c-5.551-9.9-10.526-14.977-10.576-15.026l-.184-.186.024-.261c.048-.528,4.755-52.983-.537-70.944-3.168-10.758-13.277-20.606-21.209-20.661H576.9c-3.922-.02-6.754,2.424-8.192,7.068a24.3,24.3,0,0,0-.9,4.625,206.731,206.731,0,0,1-.3,26.511,65.29,65.29,0,0,1-2.675,14.69c-4.235,12.5-14.8,48.834-15.8,64.542-.975,15.245,13.125,79.534,13.267,80.181l-1.1.241c-.583-2.65-14.276-65.091-13.291-80.494,1.01-15.813,11.609-52.286,15.858-64.831a64.214,64.214,0,0,0,2.62-14.429,205.794,205.794,0,0,0,.294-26.39l0-.046,0-.046a25.465,25.465,0,0,1,.951-4.887c2.02-6.521,6.152-7.876,9.271-7.86h.021c3.994.028,8.729,2.377,12.991,6.445a34.742,34.742,0,0,1,9.289,15.023c5.218,17.71,1,66.655.6,71.109a80.24,80.24,0,0,1,10.549,15.032,126.667,126.667,0,0,1,14.663,45.428c1.213,9.239.744,17.6-1.394,24.853a39.711,39.711,0,0,1-8.288,15.223A33.973,33.973,0,0,1,601.584,1187.348Z",
    transform: "translate(-547.859 -984.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11286",
    "data-name": "Group 11286",
    transform: "translate(651.814 327.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11232",
    "data-name": "Group 11232",
    transform: "translate(0.49 54.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    d: "M1484.857,819.394s-22.527-1.317-27.279,7.934,14.717,28.783,26.707,28.376S1484.857,819.394,1484.857,819.394Z",
    transform: "translate(-1456.846 -819.329)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11233",
    "data-name": "Group 11233",
    transform: "translate(64.681 237.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3542",
    "data-name": "Path 3542",
    d: "M1710.179,1419.065s-59.753-16.568-76.719-52.353,46.724-52.449,45.827-52.28,68.816,5.574,75.328,15.484,34.692,51,26.625,52.527S1710.179,1419.065,1710.179,1419.065Z",
    transform: "translate(-1630.584 -1314.431)",
    fill: "#ed7163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11255",
    "data-name": "Group 11255",
    transform: "translate(28.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11235",
    "data-name": "Group 11235",
    transform: "translate(5.678 5.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11234",
    "data-name": "Group 11234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M1546.716,694.125c0-.084,0-.168.009-.251a5.577,5.577,0,0,1,5.15-5.318c.083-.007.167-.013.251-.017.028,0,.055,0,.083-.005l124.42-2.025c.028,0,.055,0,.083,0,.084,0,.168,0,.251.009a5.578,5.578,0,0,1,5.321,5.148q.011.124.017.25c0,.028.005.055.006.083l4.21,258.7a4.871,4.871,0,0,1-4.791,4.949L1555.872,957.7a4.871,4.871,0,0,1-4.949-4.791l-4.21-258.7C1546.713,694.18,1546.716,694.153,1546.716,694.125Z",
    transform: "translate(-1546.713 -686.509)",
    fill: "#d0f6fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11236",
    "data-name": "Group 11236",
    transform: "translate(1.396 2.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M1677.118,685.34l-10.289-6.8L1545.6,680.823l-10.481,9.526s1.2,10.8,1.872,10.959,141.414-.5,141.373-2.665S1677.118,685.34,1677.118,685.34Z",
    transform: "translate(-1535.123 -678.538)",
    fill: "#f48a21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11249",
    "data-name": "Group 11249",
    transform: "translate(118.902 13.488)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11240",
    "data-name": "Group 11240",
    transform: "translate(11.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11239",
    "data-name": "Group 11239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11238",
    "data-name": "Group 11238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11237",
    "data-name": "Group 11237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M1884.507,709.829a1.872,1.872,0,1,0,1.841-1.9A1.869,1.869,0,0,0,1884.507,709.829Z",
    transform: "translate(-1884.506 -707.927)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11244",
    "data-name": "Group 11244",
    transform: "translate(5.79 0.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11243",
    "data-name": "Group 11243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11242",
    "data-name": "Group 11242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11241",
    "data-name": "Group 11241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M1868.834,710.085a1.872,1.872,0,1,0,1.841-1.9A1.869,1.869,0,0,0,1868.834,710.085Z",
    transform: "translate(-1868.833 -708.182)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11248",
    "data-name": "Group 11248",
    transform: "translate(0 0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11247",
    "data-name": "Group 11247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11246",
    "data-name": "Group 11246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11245",
    "data-name": "Group 11245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M1853.162,710.34a1.874,1.874,0,0,0,1.9,1.841,1.848,1.848,0,0,0,.765-.178,1.871,1.871,0,1,0-2.667-1.663Z",
    transform: "translate(-1853.161 -708.437)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11254",
    "data-name": "Group 11254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11253",
    "data-name": "Group 11253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11252",
    "data-name": "Group 11252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11251",
    "data-name": "Group 11251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11250",
    "data-name": "Group 11250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    d: "M1537.068,687.533a8.422,8.422,0,0,1,8.285-8.559l118.748-1.932a8.422,8.422,0,0,1,8.559,8.285l4.12,253.182a7.55,7.55,0,0,1-7.428,7.671l-120.493,1.961a7.55,7.55,0,0,1-7.671-7.426Zm-5.723-.049,4.162,255.788a13.9,13.9,0,0,0,14.121,13.668L1668.873,955a13.9,13.9,0,0,0,13.668-14.12l-4.162-255.788a13.9,13.9,0,0,0-14.121-13.669l-119.245,1.94A13.9,13.9,0,0,0,1531.346,687.484Z",
    transform: "translate(-1531.344 -671.421)",
    fill: "#20111d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11256",
    "data-name": "Group 11256",
    transform: "translate(130.431 107.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M1907.425,1238.856c-28.453,24.112-62.292,40.572-98.886,51.277l.059-49.115.02-16.891,1.374-31.828v0l-.02-.1-.059-.333.342-.174.751-.379,31.848-16.015h.006l20.882-10.5.847-.425s-14.383-1.816-23.75-16.693c-.01-.013-.016-.03-.026-.043s-.01-.02-.016-.03a45.53,45.53,0,0,1-4.545-9.64,57.689,57.689,0,0,1-2.212-8.773l0,0a73.7,73.7,0,0,1-.989-8.988,139.356,139.356,0,0,1-.01-14.08c.161-3.154.428-6.17.778-9.05v0c.419-3.467.959-6.73,1.582-9.785a109.618,109.618,0,0,1,6.18-20.375,64.886,64.886,0,0,1,5.4-10.6s-3.026-10.827-6.1-24.36q-.381-1.656-.751-3.358c-3.345-15.2-6.457-32.846-5.451-42.365,1.064-10.154,7.524-19.99,14.3-23.477a10.488,10.488,0,0,1,5.7-1.3c2.5.221,4.835,1.608,6.724,4.509.28.428.551.893.811,1.387a21.424,21.424,0,0,1,.956,2.119s0,.007.007.013c.293.745.564,1.542.814,2.4,0,0,.464,3.83,1.41,9.281.046.26.092.524.138.794.046.25.089.5.132.748.765,4.189,1.78,9.136,3.072,13.981v0c0,.007,0,.01,0,.013s0,0,0,.007c.1.385.208.774.313,1.157a65.645,65.645,0,0,0,5.231,13.839c7.02,12.6,23.476,45.7,27.253,60.769s1.444,81.411,1.444,81.411v0Z",
    transform: "translate(-1808.539 -961.409)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11259",
    "data-name": "Group 11259",
    transform: "translate(8.908 179.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11257",
    "data-name": "Group 11257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M1500.928,1157.8l.183,9.465s15.364,10.7,14.184,28.085-11.982,21.439-11.982,21.439-21.744-20.186-22.961-28.356S1476.588,1166,1500.928,1157.8Z",
    transform: "translate(-1479.629 -1157.795)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11258",
    "data-name": "Group 11258",
    transform: "translate(3.253 32.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M1506.073,1269.7s-8.3-5.809-17.64-20.1a21.678,21.678,0,0,1,4.074-2.433c3.731-1.9,6.39-1.546,9.034.832l10.19,10.281s2.095,2.718-.659,6.81C1510.013,1266.661,1506.073,1269.7,1506.073,1269.7Z",
    transform: "translate(-1488.433 -1245.949)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11260",
    "data-name": "Group 11260",
    transform: "translate(8.281 186.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M1502.126,1229.358l-13.09-12.764c-7.124-7.095-9.689-14.022-10.588-18.586a21.922,21.922,0,0,1-.235-8.375l1.1.248c-.028.125-2.67,12.78,10.515,25.912l12.533,12.221a18.13,18.13,0,0,0,7.262-6.927c.079-.139,6.957-12.276,3.1-23.744-3.876-11.528-16.023-19.652-16.146-19.732l.619-.939c.512.338,12.59,8.411,16.592,20.313,4.021,11.958-2.887,24.135-3.183,24.647a18.819,18.819,0,0,1-8.128,7.568Z",
    transform: "translate(-1477.933 -1176.672)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11263",
    "data-name": "Group 11263",
    transform: "translate(14.934 244.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11261",
    "data-name": "Group 11261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M1512.583,1332.252l.143,7.4s12.005,8.36,11.084,21.946-9.363,16.753-9.363,16.753-16.991-15.774-17.942-22.158S1493.563,1338.665,1512.583,1332.252Z",
    transform: "translate(-1495.94 -1332.252)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11262",
    "data-name": "Group 11262",
    transform: "translate(2.542 25.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M1516.6,1419.7s-6.485-4.54-13.784-15.706a16.934,16.934,0,0,1,3.183-1.9c2.915-1.481,4.993-1.208,7.059.65l7.963,8.033s1.637,2.124-.515,5.321A26.434,26.434,0,0,1,1516.6,1419.7Z",
    transform: "translate(-1502.82 -1401.138)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11264",
    "data-name": "Group 11264",
    transform: "translate(14.431 249.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M1513.5,1388.172l-10.229-9.974c-10.669-10.627-8.552-20.646-8.457-21.067l.857.193c-.022.1-2.086,9.986,8.216,20.248l9.793,9.55a14.116,14.116,0,0,0,5.675-5.412c.062-.109,5.436-9.593,2.423-18.554-3.029-9.008-12.521-15.356-12.616-15.42l.484-.733c.4.264,9.838,6.573,12.965,15.872,3.142,9.344-2.256,18.859-2.488,19.259a14.7,14.7,0,0,1-6.351,5.914Z",
    transform: "translate(-1494.579 -1347.003)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11265",
    "data-name": "Group 11265",
    transform: "translate(161.978 283.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M1893.924,1446.937s12.9,21.006,2.776,28.929,28.617,4.042,28.409,2.938,20.151-38.7,13.211-39.1-29.113-4.229-32.87,1.629S1893.924,1446.937,1893.924,1446.937Z",
    transform: "translate(-1893.924 -1438.101)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11268",
    "data-name": "Group 11268",
    transform: "translate(7.752 123.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11266",
    "data-name": "Group 11266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M1497.8,1006.157l.183,9.466s15.363,10.7,14.184,28.085-11.982,21.44-11.982,21.44-21.745-20.187-22.961-28.356S1473.458,1014.364,1497.8,1006.157Z",
    transform: "translate(-1476.5 -1006.157)",
    fill: "#fe9f73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11267",
    "data-name": "Group 11267",
    transform: "translate(3.253 32.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M1502.943,1118.062s-8.3-5.809-17.64-20.1a21.638,21.638,0,0,1,4.074-2.433c3.731-1.9,6.39-1.546,9.034.831l10.19,10.281s2.094,2.718-.659,6.809C1506.883,1115.024,1502.943,1118.062,1502.943,1118.062Z",
    transform: "translate(-1485.303 -1094.312)",
    fill: "#f78a5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11269",
    "data-name": "Group 11269",
    transform: "translate(129.932 337.585)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 49.169,
    height: 1.124,
    transform: "matrix(0.027, -1, 1, 0.027, 0, 49.152)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11270",
    "data-name": "Group 11270",
    transform: "translate(69.619 294.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M1709.339,1513.168c-20.508-4.886-41.092-17.753-51.539-27.641a99.849,99.849,0,0,1-13.851-15.741l.941-.614a98.856,98.856,0,0,0,13.683,15.54c10.341,9.788,30.721,22.526,51.027,27.363Z",
    transform: "translate(-1643.948 -1469.171)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11271",
    "data-name": "Group 11271",
    transform: "translate(172.934 111.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M1923.606,978.839c.529-3.319,8.414-5.2,10.83-5.209,1.56-.008,5.368,29.636,6.842,30.75,0,0,.29.327-3.549,1.171a14.331,14.331,0,0,1-7.518-.322S1923.077,982.157,1923.606,978.839Z",
    transform: "translate(-1923.578 -973.63)",
    fill: "#f78a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11272",
    "data-name": "Group 11272",
    transform: "translate(7.125 130.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M1498.993,1077.717l-13.087-12.761c-7.123-7.095-9.689-14.023-10.587-18.586a21.92,21.92,0,0,1-.235-8.375l1.1.248c-.028.126-2.67,12.779,10.515,25.912l12.534,12.223c4.3-2.073,7.245-6.9,7.275-6.954.065-.113,6.943-12.25,3.086-23.718-3.876-11.528-16.023-19.652-16.146-19.733l.619-.938c.513.338,12.591,8.412,16.592,20.313,4.021,11.958-2.887,24.135-3.183,24.647-.137.23-3.313,5.451-8.133,7.57Z",
    transform: "translate(-1474.804 -1025.034)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11273",
    "data-name": "Group 11273",
    transform: "translate(27.787 29.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M1532,854.635l-1.273-103.8.736-.022,1.273,103.8Z",
    transform: "translate(-1530.727 -750.817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11274",
    "data-name": "Group 11274",
    transform: "translate(0 54.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M1462.306,843.376c-.423-.411-10.3-10.157-5.448-18.273,4.8-8.022,25.519-7.3,26.4-7.262l-.044,1.124c-.208-.007-20.933-.736-25.39,6.715-4.4,7.352,5.169,16.8,5.267,16.89Z",
    transform: "translate(-1455.519 -817.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11279",
    "data-name": "Group 11279",
    transform: "translate(200.797 278.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11278",
    "data-name": "Group 11278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11277",
    "data-name": "Group 11277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11276",
    "data-name": "Group 11276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11275",
    "data-name": "Group 11275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M1999.329,1442.292a.592.592,0,0,0,.586-.046c6.045-4.1,10.425-14.879,10.609-15.336a.593.593,0,1,0-1.1-.442c-.044.109-4.43,10.9-10.174,14.8a.593.593,0,0,0,.08,1.027Z",
    transform: "translate(-1998.989 -1426.096)",
    fill: "#000100"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11284",
    "data-name": "Group 11284",
    transform: "translate(192.613 281.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11283",
    "data-name": "Group 11283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11282",
    "data-name": "Group 11282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11281",
    "data-name": "Group 11281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11280",
    "data-name": "Group 11280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M1977.18,1447.379a.6.6,0,0,0,.472.015c6.787-2.7,13.39-12.281,13.667-12.687a.593.593,0,0,0-.979-.669c-.066.1-6.677,9.689-13.127,12.253a.594.594,0,0,0-.034,1.088Z",
    transform: "translate(-1976.84 -1433.779)",
    fill: "#000100"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11285",
    "data-name": "Group 11285",
    transform: "translate(154.197 106.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M1905.082,1163.966a33.974,33.974,0,0,1-15.274-7.032,39.707,39.707,0,0,1-10.9-13.477c-3.413-6.747-5.385-14.887-5.86-24.193a126.665,126.665,0,0,1,6.218-47.329,80.232,80.232,0,0,1,7.661-16.69c-1.2-4.31-14.183-51.687-12.25-70.048a34.745,34.745,0,0,1,6.424-16.454c3.457-4.771,7.69-7.936,11.614-8.685,3.068-.586,7.388-.01,10.558,6.052a25.48,25.48,0,0,1,1.818,4.635l.019.09a205.658,205.658,0,0,0,5.055,25.9,64.2,64.2,0,0,0,5.182,13.718c6.444,11.572,23.455,45.531,27.3,60.9,3.75,14.971,1.558,78.859,1.463,81.571l-1.124-.039c.023-.663,2.282-66.441-1.43-81.259-3.824-15.267-20.772-49.094-27.2-60.627a65.307,65.307,0,0,1-5.284-13.966A206.737,206.737,0,0,1,1904,971.018a24.3,24.3,0,0,0-1.723-4.386c-2.256-4.314-5.49-6.205-9.351-5.469-7.792,1.487-15.957,13-17.13,24.152-1.961,18.622,12.141,69.364,12.283,69.874l.071.252-.147.217c-.04.058-4.016,5.953-7.688,16.689a125.568,125.568,0,0,0-6.143,46.861c1.056,20.686,9.464,31.452,16.332,36.842a33.407,33.407,0,0,0,14.72,6.8Z",
    transform: "translate(-1872.865 -959.88)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11307",
    "data-name": "Group 11307",
    transform: "translate(376.013 391.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11287",
    "data-name": "Group 11287",
    transform: "translate(0.601 0.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M875.244,941.02,713.652,974.085a5.537,5.537,0,0,1-6.534-4.315l-19.966-97.576a5.537,5.537,0,0,1,4.315-6.535l161.592-33.065a5.537,5.537,0,0,1,6.534,4.315l19.966,97.576A5.538,5.538,0,0,1,875.244,941.02Z",
    transform: "translate(-687.038 -832.481)",
    fill: "#12355f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11288",
    "data-name": "Group 11288",
    transform: "translate(41.493 16.034)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2662",
    "data-name": "Ellipse 2662",
    cx: 39.192,
    cy: 39.192,
    r: 39.192,
    transform: "translate(0 55.426) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11293",
    "data-name": "Group 11293",
    transform: "translate(24.162 67.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11289",
    "data-name": "Group 11289",
    transform: "translate(0 24.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    "data-name": "Path 3568",
    d: "M758.147,1100.635a3.522,3.522,0,0,1-.395,1.438,2.628,2.628,0,0,1-.887.955,3.852,3.852,0,0,1-1.329.518,3.912,3.912,0,0,1-1.432.047,2.618,2.618,0,0,1-1.2-.528,3.518,3.518,0,0,1-.928-1.167,7.13,7.13,0,0,1-.621-1.87l-.373-1.822a7.125,7.125,0,0,1-.163-1.964,3.515,3.515,0,0,1,.395-1.438,2.626,2.626,0,0,1,.894-.957,3.92,3.92,0,0,1,1.335-.519,3.85,3.85,0,0,1,1.425-.045,2.632,2.632,0,0,1,1.191.529,3.522,3.522,0,0,1,.928,1.167,7.147,7.147,0,0,1,.622,1.87l.373,1.822A7.124,7.124,0,0,1,758.147,1100.635Zm-1.764-3.534a6.251,6.251,0,0,0-.445-1.421,2.923,2.923,0,0,0-.617-.893,1.665,1.665,0,0,0-.766-.42,2.212,2.212,0,0,0-1.709.349,1.669,1.669,0,0,0-.539.687,2.919,2.919,0,0,0-.217,1.064,6.276,6.276,0,0,0,.149,1.481l.373,1.822a6.268,6.268,0,0,0,.445,1.421,2.917,2.917,0,0,0,.617.893,1.664,1.664,0,0,0,.766.42,2.213,2.213,0,0,0,1.709-.35,1.659,1.659,0,0,0,.54-.687,2.911,2.911,0,0,0,.216-1.064,6.254,6.254,0,0,0-.148-1.481Z",
    transform: "translate(-750.807 -1088.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M780.249,1096.112a3.525,3.525,0,0,1-.395,1.438,2.628,2.628,0,0,1-.887.955,3.854,3.854,0,0,1-1.328.518,3.915,3.915,0,0,1-1.432.047,2.617,2.617,0,0,1-1.2-.528,3.518,3.518,0,0,1-.928-1.167,7.119,7.119,0,0,1-.621-1.87l-.373-1.822a7.125,7.125,0,0,1-.163-1.964,3.521,3.521,0,0,1,.4-1.438,2.619,2.619,0,0,1,.894-.956,3.917,3.917,0,0,1,1.335-.519,3.864,3.864,0,0,1,1.425-.046,2.629,2.629,0,0,1,1.191.53,3.522,3.522,0,0,1,.928,1.167,7.133,7.133,0,0,1,.622,1.87l.373,1.822A7.132,7.132,0,0,1,780.249,1096.112Zm-1.764-3.534a6.282,6.282,0,0,0-.445-1.421,2.931,2.931,0,0,0-.617-.893,1.677,1.677,0,0,0-.766-.42,2.215,2.215,0,0,0-1.709.35,1.662,1.662,0,0,0-.539.687,2.913,2.913,0,0,0-.217,1.064,6.285,6.285,0,0,0,.149,1.481l.373,1.822a6.269,6.269,0,0,0,.445,1.421,2.9,2.9,0,0,0,.618.893,1.658,1.658,0,0,0,.765.42,2.212,2.212,0,0,0,1.709-.349,1.67,1.67,0,0,0,.539-.687,2.924,2.924,0,0,0,.217-1.064,6.277,6.277,0,0,0-.149-1.481Z",
    transform: "translate(-764.742 -1085.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    d: "M800.946,1086.056a2.421,2.421,0,0,1-.123,1.466,5.146,5.146,0,0,1-1.1,1.5l-1.12,1.143a8.174,8.174,0,0,0-.789.9,3.246,3.246,0,0,0-.439.786,2.436,2.436,0,0,0-.155.755,3.449,3.449,0,0,0,.076.821l.058.283,4.549-.931a.31.31,0,0,1,.2.022.2.2,0,0,1,.116.152l.121.594a.222.222,0,0,1-.045.192.292.292,0,0,1-.175.106l-5.348,1.094a.271.271,0,0,1-.2-.036.243.243,0,0,1-.117-.166l-.224-1.092a4.026,4.026,0,0,1,.086-2.026,4.875,4.875,0,0,1,1.26-1.943l1.18-1.2q.361-.369.588-.64a2.407,2.407,0,0,0,.34-.512,1.309,1.309,0,0,0,.127-.482,2.094,2.094,0,0,0-.047-.538,1.231,1.231,0,0,0-.682-.962,2.836,2.836,0,0,0-1.627-.011q-.526.107-1.162.3t-1.186.39l-.054.011q-.216.044-.266-.2l-.1-.478a.2.2,0,0,1,.041-.18.545.545,0,0,1,.166-.119,7.843,7.843,0,0,1,1.112-.441,12.125,12.125,0,0,1,1.235-.324,4.18,4.18,0,0,1,2.548.083A2.178,2.178,0,0,1,800.946,1086.056Z",
    transform: "translate(-778.47 -1082.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M823.678,1089.69a.222.222,0,0,1-.159.117l-.742.152a.223.223,0,0,1-.192-.045.291.291,0,0,1-.106-.175l-1.737-8.49-1.587,1.112a.457.457,0,0,1-.167.077q-.121.025-.152-.123l-.141-.689a.139.139,0,0,1,.013-.108.539.539,0,0,1,.086-.095l1.84-1.389a.666.666,0,0,1,.267-.139l.553-.113a.259.259,0,0,1,.309.2l1.944,9.5A.29.29,0,0,1,823.678,1089.69Z",
    transform: "translate(-793.609 -1079.776)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11290",
    "data-name": "Group 11290",
    transform: "translate(39.991 16.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M866.386,1078.487a3.515,3.515,0,0,1-.395,1.438,2.624,2.624,0,0,1-.887.955,3.864,3.864,0,0,1-1.329.518,3.908,3.908,0,0,1-1.432.046,2.616,2.616,0,0,1-1.2-.528,3.519,3.519,0,0,1-.928-1.167,7.129,7.129,0,0,1-.621-1.87l-.373-1.822a7.125,7.125,0,0,1-.163-1.963,3.516,3.516,0,0,1,.395-1.438,2.616,2.616,0,0,1,.894-.956,3.9,3.9,0,0,1,1.335-.52,3.856,3.856,0,0,1,1.425-.046,2.63,2.63,0,0,1,1.191.53,3.521,3.521,0,0,1,.928,1.167,7.127,7.127,0,0,1,.622,1.87l.373,1.822A7.143,7.143,0,0,1,866.386,1078.487Zm-1.764-3.534a6.272,6.272,0,0,0-.445-1.421,2.923,2.923,0,0,0-.617-.893,1.668,1.668,0,0,0-.766-.42,2.213,2.213,0,0,0-1.709.35,1.668,1.668,0,0,0-.539.687,2.911,2.911,0,0,0-.217,1.064,6.257,6.257,0,0,0,.149,1.481l.373,1.822a6.272,6.272,0,0,0,.445,1.421,2.915,2.915,0,0,0,.617.893,1.66,1.66,0,0,0,.766.42,2.212,2.212,0,0,0,1.709-.349,1.669,1.669,0,0,0,.539-.687,2.914,2.914,0,0,0,.216-1.064,6.256,6.256,0,0,0-.149-1.481Z",
    transform: "translate(-859.046 -1066.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    d: "M887.883,1074.779a2.424,2.424,0,0,1-.511,1.04,3.013,3.013,0,0,1-.953.736,5.213,5.213,0,0,1-1.322.446,8.842,8.842,0,0,1-1.239.168q-.591.035-1.1.026a.462.462,0,0,1-.2-.052.214.214,0,0,1-.109-.156l-.095-.465a.207.207,0,0,1,.182-.277l.041-.009q.624-.043,1.229-.111t1.077-.164a2.433,2.433,0,0,0,1.515-.773,1.837,1.837,0,0,0,.211-1.514l-.058-.282a2.3,2.3,0,0,0-.188-.543,1.53,1.53,0,0,0-.365-.478,1.409,1.409,0,0,0-.567-.3,1.707,1.707,0,0,0-.794,0l-2.456.5a.226.226,0,0,1-.306-.191l-.1-.472a.231.231,0,0,1,.2-.309l2.456-.5a1.894,1.894,0,0,0,.766-.311,1.241,1.241,0,0,0,.4-.481,1.5,1.5,0,0,0,.13-.566,2.416,2.416,0,0,0-.045-.565l-.038-.188a1.5,1.5,0,0,0-.728-1.119,2.7,2.7,0,0,0-1.7-.051,9.574,9.574,0,0,0-1.088.286l-1.138.38-.041.009a.207.207,0,0,1-.276-.183l-.1-.479a.221.221,0,0,1,.041-.179.426.426,0,0,1,.163-.133q.463-.209,1.02-.408a8.785,8.785,0,0,1,1.2-.332,6.953,6.953,0,0,1,1.4-.154,2.86,2.86,0,0,1,1.149.222,2.147,2.147,0,0,1,.847.671,2.923,2.923,0,0,1,.5,1.205l.038.189a2.465,2.465,0,0,1-.07,1.308.7.7,0,1,0-.088,1.354,2.2,2.2,0,0,1,.5.446,2.449,2.449,0,0,1,.335.536,2.714,2.714,0,0,1,.189.58l.058.284A3.177,3.177,0,0,1,887.883,1074.779Z",
    transform: "translate(-872.619 -1063.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    d: "M909.984,1070.257a2.43,2.43,0,0,1-.511,1.04,3.009,3.009,0,0,1-.953.736,5.218,5.218,0,0,1-1.322.446,8.82,8.82,0,0,1-1.239.168q-.591.035-1.1.025a.463.463,0,0,1-.2-.051.216.216,0,0,1-.109-.156l-.095-.465a.207.207,0,0,1,.182-.277l.04-.008q.624-.043,1.229-.111t1.077-.164a2.434,2.434,0,0,0,1.516-.772,1.836,1.836,0,0,0,.21-1.514l-.058-.282a2.314,2.314,0,0,0-.188-.543,1.528,1.528,0,0,0-.365-.479,1.406,1.406,0,0,0-.567-.3,1.707,1.707,0,0,0-.794,0l-2.456.5a.226.226,0,0,1-.306-.191l-.1-.472a.232.232,0,0,1,.2-.309l2.457-.5a1.893,1.893,0,0,0,.766-.311,1.241,1.241,0,0,0,.4-.481,1.494,1.494,0,0,0,.13-.566,2.406,2.406,0,0,0-.045-.565l-.038-.188a1.5,1.5,0,0,0-.728-1.118,2.7,2.7,0,0,0-1.7-.051,9.416,9.416,0,0,0-1.088.286l-1.138.38-.041.008a.207.207,0,0,1-.276-.183l-.1-.478a.219.219,0,0,1,.041-.179.42.42,0,0,1,.163-.133q.463-.209,1.02-.408a8.736,8.736,0,0,1,1.2-.332,6.952,6.952,0,0,1,1.4-.153,2.843,2.843,0,0,1,1.149.222,2.145,2.145,0,0,1,.848.671,2.924,2.924,0,0,1,.5,1.205l.039.189a2.464,2.464,0,0,1-.07,1.308.7.7,0,1,0-.089,1.354,2.213,2.213,0,0,1,.5.446,2.448,2.448,0,0,1,.335.536,2.75,2.75,0,0,1,.189.58l.058.283A3.179,3.179,0,0,1,909.984,1070.257Z",
    transform: "translate(-886.554 -1060.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M931.917,1067.543a.223.223,0,0,1-.159.117l-.742.152a.222.222,0,0,1-.192-.045.292.292,0,0,1-.106-.175l-1.737-8.49-1.587,1.112a.461.461,0,0,1-.167.077c-.081.016-.132-.025-.152-.124l-.141-.688a.141.141,0,0,1,.013-.108.562.562,0,0,1,.086-.095l1.839-1.389a.666.666,0,0,1,.267-.139l.553-.113a.255.255,0,0,1,.2.037.251.251,0,0,1,.111.167l1.945,9.5A.29.29,0,0,1,931.917,1067.543Z",
    transform: "translate(-901.848 -1057.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11291",
    "data-name": "Group 11291",
    transform: "translate(80.351 8.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    d: "M975.384,1055.48l-1.174.24.492,2.4a.31.31,0,0,1-.023.2.206.206,0,0,1-.154.116l-.791.162a.208.208,0,0,1-.187-.046.31.31,0,0,1-.1-.176l-.491-2.4-3.889.8a.641.641,0,0,1-.454-.026.57.57,0,0,1-.205-.387l-.1-.513a.829.829,0,0,1,.06-.532l2.837-6.416a.7.7,0,0,1,.1-.176.4.4,0,0,1,.242-.12l.806-.165q.355-.073.416.223l1.232,6.021,1.174-.24a.264.264,0,0,1,.2.031.233.233,0,0,1,.11.162l.112.547A.227.227,0,0,1,975.384,1055.48Zm-3.57-5.148c-.011-.054-.035-.077-.07-.07l-.014,0c-.036.007-.066.042-.091.1l-2.2,5.05a.182.182,0,0,0-.019.116q.017.081.124.059l3.213-.657Z",
    transform: "translate(-968.282 -1043.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M996.282,1051.989a3.164,3.164,0,0,1-.412,1.385,2.655,2.655,0,0,1-.962.935,4.882,4.882,0,0,1-1.48.535,11.49,11.49,0,0,1-1.371.209q-.56.043-1,.033a.768.768,0,0,1-.246-.035.193.193,0,0,1-.131-.159l-.109-.533a.236.236,0,0,1,.03-.2.257.257,0,0,1,.163-.1.1.1,0,0,1,.042,0,.1.1,0,0,0,.042,0,9.827,9.827,0,0,0,1.12-.061q.584-.063,1.232-.2a2.951,2.951,0,0,0,1.2-.476,1.678,1.678,0,0,0,.577-.755,2.327,2.327,0,0,0,.118-1,10.135,10.135,0,0,0-.18-1.223l-.03-.149q-.413.183-.888.371a6.471,6.471,0,0,1-1.1.315,5.855,5.855,0,0,1-1.29.123,2.988,2.988,0,0,1-1.153-.241,2.328,2.328,0,0,1-.907-.722,3.108,3.108,0,0,1-.547-1.3l-.017-.081a3.686,3.686,0,0,1,.3-2.678,3.787,3.787,0,0,1,4.883-.978,4.2,4.2,0,0,1,1.473,2.729l.483,2.362A6.769,6.769,0,0,1,996.282,1051.989Zm-1.854-4.011a5.913,5.913,0,0,0-.415-1.338,2.233,2.233,0,0,0-.576-.786,1.459,1.459,0,0,0-.742-.325,2.689,2.689,0,0,0-.9.044,2.913,2.913,0,0,0-.833.3,1.607,1.607,0,0,0-.578.539,1.9,1.9,0,0,0-.274.827,3.827,3.827,0,0,0,.086,1.174l.016.081a2.11,2.11,0,0,0,.36.866,1.481,1.481,0,0,0,.589.475,1.954,1.954,0,0,0,.729.159,3.443,3.443,0,0,0,.794-.072q.243-.049.522-.127t.549-.169q.27-.09.51-.188c.16-.066.3-.123.407-.174Z",
    transform: "translate(-981.266 -1041.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M1017.423,1041.76a2.424,2.424,0,0,1-.123,1.467,5.154,5.154,0,0,1-1.1,1.5l-1.12,1.143a8.209,8.209,0,0,0-.789.9,3.258,3.258,0,0,0-.439.786,2.445,2.445,0,0,0-.155.756,3.438,3.438,0,0,0,.076.821l.058.284,4.549-.93a.31.31,0,0,1,.2.022.2.2,0,0,1,.116.152l.121.594a.222.222,0,0,1-.045.192.293.293,0,0,1-.175.106l-5.348,1.094a.272.272,0,0,1-.2-.036.243.243,0,0,1-.117-.166l-.224-1.092a4.024,4.024,0,0,1,.086-2.025,4.875,4.875,0,0,1,1.259-1.943l1.18-1.2q.361-.369.588-.64a2.427,2.427,0,0,0,.339-.512,1.311,1.311,0,0,0,.127-.483,2.091,2.091,0,0,0-.047-.538,1.232,1.232,0,0,0-.682-.963,2.84,2.84,0,0,0-1.627-.011q-.526.108-1.162.3t-1.186.39l-.054.011c-.144.029-.232-.037-.266-.2l-.1-.478a.194.194,0,0,1,.041-.179.532.532,0,0,1,.166-.119,7.777,7.777,0,0,1,1.112-.441,11.94,11.94,0,0,1,1.235-.324,4.18,4.18,0,0,1,2.548.083A2.179,2.179,0,0,1,1017.423,1041.76Z",
    transform: "translate(-995.317 -1038.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M1040.156,1045.4a.222.222,0,0,1-.159.117l-.742.152a.221.221,0,0,1-.192-.045.29.29,0,0,1-.106-.175l-1.737-8.49-1.587,1.112a.462.462,0,0,1-.167.077c-.081.016-.132-.025-.152-.124l-.141-.688a.141.141,0,0,1,.013-.108.54.54,0,0,1,.086-.095l1.839-1.389a.662.662,0,0,1,.267-.139l.553-.113a.259.259,0,0,1,.309.2l1.944,9.5A.29.29,0,0,1,1040.156,1045.4Z",
    transform: "translate(-1010.456 -1035.481)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11292",
    "data-name": "Group 11292",
    transform: "translate(119.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M1081.459,1028.657a2.423,2.423,0,0,1-.123,1.467,5.149,5.149,0,0,1-1.1,1.5l-1.12,1.143a8.22,8.22,0,0,0-.789.9,3.265,3.265,0,0,0-.439.786,2.457,2.457,0,0,0-.156.756,3.452,3.452,0,0,0,.077.821l.058.284,4.548-.931a.313.313,0,0,1,.2.022.2.2,0,0,1,.116.152l.122.594a.221.221,0,0,1-.045.192.293.293,0,0,1-.175.106l-5.348,1.094a.271.271,0,0,1-.2-.036.242.242,0,0,1-.117-.166l-.224-1.092a4.019,4.019,0,0,1,.086-2.025,4.881,4.881,0,0,1,1.259-1.943l1.18-1.2q.361-.369.588-.64a2.407,2.407,0,0,0,.339-.512,1.313,1.313,0,0,0,.127-.483,2.11,2.11,0,0,0-.047-.538,1.233,1.233,0,0,0-.682-.963,2.837,2.837,0,0,0-1.627-.011q-.527.107-1.162.3t-1.186.39l-.054.011c-.144.029-.232-.037-.266-.2l-.1-.479a.194.194,0,0,1,.041-.179.523.523,0,0,1,.166-.119,7.773,7.773,0,0,1,1.112-.441,11.949,11.949,0,0,1,1.235-.324,4.181,4.181,0,0,1,2.548.083A2.178,2.178,0,0,1,1081.459,1028.657Z",
    transform: "translate(-1075.194 -1021.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M1104.966,1029.669a3.527,3.527,0,0,1-.4,1.438,2.631,2.631,0,0,1-.887.955,3.865,3.865,0,0,1-1.328.518,3.906,3.906,0,0,1-1.432.047,2.617,2.617,0,0,1-1.2-.528,3.519,3.519,0,0,1-.928-1.167,7.118,7.118,0,0,1-.622-1.87l-.373-1.822a7.135,7.135,0,0,1-.163-1.963,3.526,3.526,0,0,1,.395-1.438,2.623,2.623,0,0,1,.894-.956,3.908,3.908,0,0,1,1.335-.52,3.864,3.864,0,0,1,1.425-.045,2.626,2.626,0,0,1,1.191.53,3.524,3.524,0,0,1,.928,1.167,7.15,7.15,0,0,1,.622,1.87l.373,1.822A7.131,7.131,0,0,1,1104.966,1029.669Zm-1.764-3.534a6.285,6.285,0,0,0-.445-1.421,2.924,2.924,0,0,0-.617-.893,1.667,1.667,0,0,0-.766-.42,2.213,2.213,0,0,0-1.709.349,1.669,1.669,0,0,0-.539.687,2.918,2.918,0,0,0-.217,1.064,6.268,6.268,0,0,0,.149,1.481l.373,1.822a6.305,6.305,0,0,0,.444,1.421,2.9,2.9,0,0,0,.618.893,1.657,1.657,0,0,0,.765.42,2.212,2.212,0,0,0,1.709-.349,1.663,1.663,0,0,0,.539-.687,2.914,2.914,0,0,0,.217-1.064,6.282,6.282,0,0,0-.149-1.481Z",
    transform: "translate(-1089.338 -1018.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M1125.662,1019.612a2.422,2.422,0,0,1-.123,1.466,5.144,5.144,0,0,1-1.1,1.5l-1.12,1.143a8.26,8.26,0,0,0-.789.9,3.26,3.26,0,0,0-.439.786,2.457,2.457,0,0,0-.156.756,3.469,3.469,0,0,0,.077.821l.058.283,4.549-.931a.313.313,0,0,1,.2.022.2.2,0,0,1,.116.152l.122.594a.222.222,0,0,1-.045.192.292.292,0,0,1-.175.106l-5.349,1.094a.271.271,0,0,1-.2-.036.243.243,0,0,1-.117-.166l-.224-1.092a4.024,4.024,0,0,1,.086-2.026,4.882,4.882,0,0,1,1.26-1.943l1.18-1.2q.361-.369.588-.64a2.423,2.423,0,0,0,.339-.512,1.3,1.3,0,0,0,.127-.483,2.09,2.09,0,0,0-.047-.538,1.233,1.233,0,0,0-.682-.963,2.841,2.841,0,0,0-1.627-.011q-.526.107-1.162.3t-1.186.39l-.054.011q-.215.044-.266-.2l-.1-.479a.193.193,0,0,1,.041-.179.524.524,0,0,1,.166-.119,7.792,7.792,0,0,1,1.112-.442,12.025,12.025,0,0,1,1.235-.324,4.184,4.184,0,0,1,2.548.083A2.18,2.18,0,0,1,1125.662,1019.612Z",
    transform: "translate(-1103.065 -1016.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M1148.4,1023.248a.223.223,0,0,1-.159.117l-.742.152a.22.22,0,0,1-.192-.045.287.287,0,0,1-.106-.175l-1.737-8.49-1.586,1.112a.462.462,0,0,1-.167.076q-.121.025-.152-.124l-.141-.688a.141.141,0,0,1,.013-.108.562.562,0,0,1,.086-.1l1.839-1.388a.664.664,0,0,1,.267-.139l.554-.113a.258.258,0,0,1,.309.2l1.944,9.5A.289.289,0,0,1,1148.4,1023.248Z",
    transform: "translate(-1118.204 -1013.333)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11294",
    "data-name": "Group 11294",
    transform: "translate(27.545 109.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2254",
    "data-name": "Rectangle 2254",
    width: 28.125,
    height: 8.057,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 0, 5.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11295",
    "data-name": "Group 11295",
    transform: "translate(135.767 6.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2255",
    "data-name": "Rectangle 2255",
    width: 28.125,
    height: 4.834,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 0, 5.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11296",
    "data-name": "Group 11296",
    transform: "translate(115.876 15.048)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2256",
    "data-name": "Rectangle 2256",
    width: 50.195,
    height: 4.834,
    transform: "translate(0 10.062) rotate(-11.564)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11297",
    "data-name": "Group 11297",
    transform: "translate(29.894 101.696)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2257",
    "data-name": "Rectangle 2257",
    width: 123.192,
    height: 8.057,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 0, 24.696)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11298",
    "data-name": "Group 11298",
    transform: "translate(163.27 98.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M1135.286,1100.29a4.028,4.028,0,1,1-4.754-3.139A4.028,4.028,0,0,1,1135.286,1100.29Z",
    transform: "translate(-1127.311 -1097.069)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11299",
    "data-name": "Group 11299",
    transform: "translate(174.32 96.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M1165.194,1094.17a4.028,4.028,0,1,1-4.754-3.139A4.028,4.028,0,0,1,1165.194,1094.17Z",
    transform: "translate(-1157.219 -1090.949)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11300",
    "data-name": "Group 11300",
    transform: "translate(10.029 37.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M738.6,933.238l2.809,13.729a1.292,1.292,0,0,1-1.007,1.525L716.917,953.3a1.294,1.294,0,0,1-1.528-1.006l-2.809-13.73a1.3,1.3,0,0,1,1.009-1.528l23.487-4.806A1.293,1.293,0,0,1,738.6,933.238Z",
    transform: "translate(-712.553 -932.201)",
    fill: "#fecc86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11301",
    "data-name": "Group 11301",
    transform: "translate(11.178 42.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M728.079,951.076,715.8,953.589l-.132-.646,11.636-2.381-.844-4.126.646-.132Z",
    transform: "translate(-715.665 -946.304)",
    fill: "#efa348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11302",
    "data-name": "Group 11302",
    transform: "translate(25.546 47.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M756.5,967.079l-.646.132-1.307-6.385,12.293-2.515.132.646-11.647,2.383Z",
    transform: "translate(-754.552 -958.31)",
    fill: "#efa348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11303",
    "data-name": "Group 11303",
    transform: "translate(26.933 38.899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2258",
    "data-name": "Rectangle 2258",
    width: 0.659,
    height: 6.983,
    transform: "translate(0 0.132) rotate(-11.566)",
    fill: "#efa348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11304",
    "data-name": "Group 11304",
    transform: "translate(27.973 40.718)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2259",
    "data-name": "Rectangle 2259",
    width: 8.739,
    height: 0.659,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 0, 1.752)",
    fill: "#efa348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11305",
    "data-name": "Group 11305",
    transform: "translate(11.952 51.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M725.506,973.393l-.646.132-.453-2.213-6.518,1.334-.132-.646,7.164-1.466Z",
    transform: "translate(-717.758 -970.534)",
    fill: "#efa348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11306",
    "data-name": "Group 11306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M874.9,940.358l-162.763,33.3a5.44,5.44,0,0,1-6.413-4.234l-20.206-98.747a5.44,5.44,0,0,1,4.234-6.413l162.763-33.3a5.44,5.44,0,0,1,6.413,4.234l20.206,98.748A5.439,5.439,0,0,1,874.9,940.358ZM689.953,865.237a4.45,4.45,0,0,0-3.464,5.246L706.7,969.23a4.45,4.45,0,0,0,5.246,3.464L874.7,939.39a4.45,4.45,0,0,0,3.463-5.246L857.962,835.4a4.45,4.45,0,0,0-5.246-3.464Z",
    transform: "translate(-685.41 -830.853)",
    fill: "#1d1d1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11311",
    "data-name": "Group 11311",
    transform: "translate(689.012 404.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11308",
    "data-name": "Group 11308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2663",
    "data-name": "Ellipse 2663",
    cx: 48.31,
    cy: 48.31,
    r: 48.31,
    transform: "translate(0 68.321) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11310",
    "data-name": "Group 11310",
    transform: "translate(40.621 38.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11309",
    "data-name": "Group 11309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M1677.433,1023.956l-18.22-25.339a2.675,2.675,0,1,1,4.344-3.123l14.073,19.571,35.181-44.631a2.675,2.675,0,1,1,4.2,3.312Z",
    transform: "translate(-1658.709 -969.415)",
    fill: "#5ab3bf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M1778.273,1138.033l19.922,19.684-8.726-31.264Z",
    transform: "translate(-1004.354 -626.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2260",
    "data-name": "Rectangle 2260",
    width: 82.616,
    height: 4.105,
    transform: "translate(718.011 556.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2261",
    "data-name": "Rectangle 2261",
    width: 82.616,
    height: 4.105,
    transform: "translate(718.011 573.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11314",
    "data-name": "Group 11314",
    transform: "translate(401.925 142.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11312",
    "data-name": "Group 11312",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M908.151,339.227a32.914,32.914,0,0,1-12.007-3.364l1-2.015a30.672,30.672,0,0,0,11.19,3.137Zm12.4-.963-.54-2.184a32.846,32.846,0,0,0,10.651-4.751l1.267,1.859A35.085,35.085,0,0,1,920.55,338.264Zm-34.469-9.7a52.9,52.9,0,0,1-7.663-9.706l1.91-1.189a50.637,50.637,0,0,0,7.334,9.294Zm54.769-4.058-1.817-1.327a39.059,39.059,0,0,0,5.39-10.435l2.129.728A41.318,41.318,0,0,1,940.85,324.507Zm-175.2-4.516-2.245-.148a105.865,105.865,0,0,1,1.522-12.165l2.212.408A103.589,103.589,0,0,0,765.651,319.991Zm107.262-12.154a81.563,81.563,0,0,1-3.624-11.742l2.193-.5A79.329,79.329,0,0,0,875,307.01Zm76.043-6.519-2.245-.15c.071-1.068.108-2.162.108-3.251a52.183,52.183,0,0,0-.722-8.575l2.219-.371a54.44,54.44,0,0,1,.753,8.946C949.068,299.056,949.031,300.2,948.955,301.318ZM769.99,296.429l-2.151-.657a109.9,109.9,0,0,1,4.234-11.5l2.065.894A107.659,107.659,0,0,0,769.99,296.429Zm97.38-12.443c-.434-4.11-.743-8.2-.917-12.165l2.247-.1c.172,3.916.477,7.963.907,12.027Zm75.551-6.088a66.071,66.071,0,0,0-5.329-10.65l1.915-1.181a68.276,68.276,0,0,1,5.511,11.014Zm-163.411-3.47-1.953-1.116a111.2,111.2,0,0,1,6.661-10.288l1.818,1.325A109.06,109.06,0,0,0,779.51,274.428Zm367.062-.053-2.145-.681a88.075,88.075,0,0,0,2.851-11.623l2.217.382A90.362,90.362,0,0,1,1146.573,274.376Zm-277.992-14.7-2.249-.058c.1-4.132.367-8.229.779-12.179l2.238.233C868.943,251.562,868.685,255.6,868.581,259.674Zm61.946-2.049a88.38,88.38,0,0,0-8.416-8.507l1.491-1.684a90.628,90.628,0,0,1,8.631,8.724ZM793.64,255.06l-1.658-1.521a106.866,106.866,0,0,1,8.791-8.546l1.472,1.7A104.558,104.558,0,0,0,793.64,255.06Zm357.029-4.839-2.25-.041q.013-.672.012-1.342a73.326,73.326,0,0,0-.761-10.552l2.226-.324a75.568,75.568,0,0,1,.785,10.876Q1150.681,249.528,1150.669,250.222Zm-238-8.5c-2.79-1.942-5.771-3.822-8.86-5.59q-.668-.382-1.337-.752l1.088-1.969q.683.378,1.367.768c3.146,1.8,6.183,3.717,9.027,5.7Zm-100.9-2.319-1.257-1.866a97.246,97.246,0,0,1,10.583-6.2l1.011,2.01A94.943,94.943,0,0,0,811.768,239.4Zm59.343-3.618-2.208-.43c.788-4.051,1.768-8.045,2.911-11.871l2.156.644C872.847,227.885,871.885,231.807,871.111,235.786Zm20.541-5.548a88.475,88.475,0,0,0-11.386-3.688l.545-2.183a90.744,90.744,0,0,1,11.677,3.782Zm-58.523-1.553-.734-2.127a87.611,87.611,0,0,1,11.847-3.184l.429,2.208A85.436,85.436,0,0,0,833.129,228.686Zm311.862-2.012a77.479,77.479,0,0,0-4.494-11.054l2.014-1a79.832,79.832,0,0,1,4.625,11.376Zm-276.5-2.185a81.664,81.664,0,0,0-11.949-.328l-.1-2.247a83.849,83.849,0,0,1,12.28.337Zm9.523-11.65-2.074-.873a106.618,106.618,0,0,1,5.384-10.993l1.96,1.105A104.249,104.249,0,0,0,878.01,212.839Zm256.4-7.514a97.449,97.449,0,0,0-7.4-9.424l1.683-1.493a99.718,99.718,0,0,1,7.567,9.643ZM889.776,192.016l-1.813-1.332a101.833,101.833,0,0,1,7.836-9.416l1.639,1.541A99.613,99.613,0,0,0,889.776,192.016Zm228.794-4.639c-2.894-2.627-6.015-5.2-9.28-7.641l1.348-1.8c3.321,2.486,6.5,5.1,9.444,7.776Zm-212.422-12.8-1.447-1.723a109.9,109.9,0,0,1,9.805-7.331l1.245,1.874A107.65,107.65,0,0,0,906.148,174.578Zm193.208-1.635c-3.338-2.086-6.854-4.1-10.453-5.987l1.045-1.993c3.648,1.913,7.215,3.956,10.6,6.071Zm-21.319-11.206c-3.63-1.593-7.4-3.1-11.2-4.484l.769-2.114c3.845,1.4,7.658,2.925,11.332,4.538Zm-151.952-.449-1.044-1.993c3.546-1.857,7.28-3.587,11.1-5.142l.849,2.084C933.236,157.765,929.567,159.465,926.085,161.288Zm129.295-7.807c-3.827-1.131-7.755-2.166-11.676-3.075l.508-2.192c3.964.919,7.936,1.965,11.806,3.109ZM948.318,152.2l-.663-2.15c3.821-1.178,7.8-2.227,11.814-3.12l.488,2.2C956,150.007,952.082,151.042,948.318,152.2Zm83.55-4.177c-3.957-.676-7.979-1.243-11.953-1.684l.249-2.236c4.017.446,8.082,1.019,12.082,1.7Zm-60.061-1.066-.324-2.226c3.965-.577,8.047-1.027,12.135-1.336l.171,2.243C979.752,145.945,975.721,146.389,971.807,146.959Zm36.083-1.593c-4.027-.205-8.07-.287-12.055-.244l-.024-2.25c4.024-.044,8.12.04,12.193.247Z",
    transform: "translate(-763.406 -142.861)",
    fill: "#6095ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11313",
    "data-name": "Group 11313",
    transform: "translate(373.966 142.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M1777.567,534.357l-2-1.038c.932-1.792,1.819-3.612,2.637-5.407l2.047.932C1779.421,530.676,1778.516,532.53,1777.567,534.357Z",
    transform: "translate(-1775.571 -527.912)",
    fill: "#6095ab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11339",
    "data-name": "Group 11339",
    transform: "translate(743.108 270.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11322",
    "data-name": "Group 11322",
    transform: "translate(0 7.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11321",
    "data-name": "Group 11321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11320",
    "data-name": "Group 11320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11319",
    "data-name": "Group 11319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11318",
    "data-name": "Group 11318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11317",
    "data-name": "Group 11317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11316",
    "data-name": "Group 11316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11315",
    "data-name": "Group 11315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M1706.857,538.779l-12.495,21.537s18.083-14.48,18.519-14.827,16.513-23.742,16.513-23.742l7.148-2.046-11.348-3.041Z",
    transform: "translate(-1694.362 -516.66)",
    fill: "#0d7275"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11330",
    "data-name": "Group 11330",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11329",
    "data-name": "Group 11329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11328",
    "data-name": "Group 11328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11327",
    "data-name": "Group 11327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11326",
    "data-name": "Group 11326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11325",
    "data-name": "Group 11325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11324",
    "data-name": "Group 11324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11323",
    "data-name": "Group 11323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M1725.194,503.551l-8.061-7.681-22.771,51.337Z",
    transform: "translate(-1694.361 -495.87)",
    fill: "#108387"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338",
    transform: "translate(0 12.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11337",
    "data-name": "Group 11337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11336",
    "data-name": "Group 11336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11335",
    "data-name": "Group 11335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11334",
    "data-name": "Group 11334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11333",
    "data-name": "Group 11333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11332",
    "data-name": "Group 11332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11331",
    "data-name": "Group 11331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M1740.066,540.563l-10.673-10.134L1694.361,569Z",
    transform: "translate(-1694.361 -530.428)",
    fill: "#108387"
  })))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.ebc62f866d1ffec61f98b47b5ab91ea3.svg";
export { ForwardRef as ReactComponent };